const RECOVERY_META_KEY = 'react_boot_recovery_meta_v1';
const RECOVERY_WINDOW_MS = 60 * 1000;
const MAX_RECOVERY_ATTEMPTS = 2;
const recoveries = new WeakMap();

export function getErrorMessage(errorLike) {
    if (!errorLike) return '';
    if (typeof errorLike === 'string') return errorLike;
    return String(errorLike?.message || errorLike?.reason?.message || errorLike?.reason || '');
}

export function isAssetLoadFailure(errorLike) {
    const message = getErrorMessage(errorLike).toLowerCase();
    return message.includes('loading chunk')
        || message.includes('chunkloaderror')
        || message.includes('failed to fetch dynamically imported module')
        || message.includes('importing a module script failed');
}

async function attemptRecovery(windowObject, navigatorObject, now) {
    if (navigatorObject?.onLine === false) return false;

    let attempts = 0;
    let startedAt = now;
    try {
        const parsed = JSON.parse(windowObject.sessionStorage.getItem(RECOVERY_META_KEY) || 'null');
        if (Number.isFinite(parsed?.startedAt) && now >= parsed.startedAt && now - parsed.startedAt <= RECOVERY_WINDOW_MS) {
            attempts = Math.max(0, Number(parsed.attempts) || 0);
            startedAt = parsed.startedAt;
        }
    } catch {
        // Un registro inválido no impide intentar una recuperación acotada.
    }
    if (attempts >= MAX_RECOVERY_ATTEMPTS) return false;

    try {
        windowObject.sessionStorage.setItem(RECOVERY_META_KEY, JSON.stringify({ attempts: attempts + 1, startedAt }));
    } catch {
        // Sin contador persistente no se recarga, para evitar un bucle entre páginas.
        return false;
    }

    try {
        if (navigatorObject?.serviceWorker) {
            const registrations = await navigatorObject.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((registration) => registration.unregister()));
        }
        if (windowObject.caches) {
            const keys = await windowObject.caches.keys();
            await Promise.all(keys.map((key) => windowObject.caches.delete(key)));
        }
    } catch {
        // Si falla la limpieza de recursos, igualmente se intenta recargar.
    }

    windowObject.location.reload();
    return true;
}

export function hardReloadForUpdatedAssets({
    windowObject = typeof window !== 'undefined' ? window : null,
    navigatorObject = typeof navigator !== 'undefined' ? navigator : null,
    now = Date.now(),
} = {}) {
    if (!windowObject) return Promise.resolve(false);
    if (recoveries.has(windowObject)) return recoveries.get(windowObject);

    const recovery = attemptRecovery(windowObject, navigatorObject, now)
        .catch(() => false)
        .then((recovered) => {
            if (!recovered) recoveries.delete(windowObject);
            return recovered;
        });
    recoveries.set(windowObject, recovery);
    return recovery;
}
